(() => {
  if (window.ssImageVideoBannerReady) return;
  window.ssImageVideoBannerReady = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const inView = new WeakMap();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) { inView.set(entry.target, entry.isIntersecting); update(entry.target); }
  }, {rootMargin: '100px 0px'});
  function load(video) {
    if (video.dataset.loaded) return;
    const sources = Array.from(video.querySelectorAll('source[data-src]'));
    const source = sources.find(item => /HD-1080p/.test(item.dataset.src)) || sources[0];
    if (!source) return;
    for (const item of sources) { if (item === source) item.src = item.dataset.src; else item.remove(); }
    video.dataset.loaded = 'true';
    video.muted = true;
    video.load();
  }
  function update(video) {
    const visible = video.getClientRects().length > 0 && inView.get(video) && !document.hidden;
    if (!visible || reducedMotion.matches) { video.pause(); return; }
    load(video);
    if (video.dataset.loaded) video.play().catch(() => {});
  }
  function init(root) {
    for (const video of root.querySelectorAll('[data-banner-video]')) {
      if (videos.has(video)) continue;
      videos.add(video);
      const slot = video.closest('[data-banner-video-slot]');
      video.addEventListener('playing', () => { slot.classList.add('is-playing'); });
      video.addEventListener('error', () => { slot.classList.remove('is-playing'); });
      observer.observe(video);
    }
  }
  function updateAll() { for (const video of videos) { if (video.isConnected) update(video); else { observer.unobserve(video); videos.delete(video); } } }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', updateAll);
  document.addEventListener('visibilitychange', updateAll);
  window.addEventListener('resize', updateAll, {passive:true});
  reducedMotion.addEventListener('change', updateAll);
})();
